import { Record, Map as ImmutableMap } from 'immutable';
import AssociationBackfillDuration from 'automation-ui-action-features/object-type-properties/AssociationBackfillDuration';
export default class AssociationOptions extends Record({
  backfillDuration: null
}, 'AssociationOptions') {
  constructor(props) {
    const propMap = ImmutableMap(props);
    super(propMap.update('backfillDuration', backfillDuration => backfillDuration ? new AssociationBackfillDuration(backfillDuration) : null));
  }
  getBackfillDuration() {
    return this.get('backfillDuration');
  }
  setBackfillDuration(backfillDuration) {
    if (backfillDuration === null) {
      return null;
    } else {
      return this.set('backfillDuration', backfillDuration);
    }
  }
}